import React from 'react';
import UI from '../../../ui';

const { WrappedButton, WrappedButtonType } = UI;

export const Footer = ({ onCancel }) => {
	return (
		<div className="footer-action">
			<WrappedButton
				buttonType={WrappedButtonType.Icon}
				label="Back to carriers settings"
				onClick={onCancel}
				dataqa="back-button"
			/>
		</div>
	);
};
